import React from 'react';
class CommunityTippBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    
    // Scope der Componente muss zu Verfügung stehen ... muss für jede Methode gemacht werden!
      this.handleCommunityTippChange = this.handleCommunityTippChange.bind(this); 

  }
  // Handler des Farbe
  handleCommunityTippChange(event) {
    this.setState({ communityTipp: event.target.value });
    this.props.onCommunityTippChange(event.target.value);
  }
 
  render() {
    return (
    
          <div className="Component CommunityTipp">
            <section id="tippCommunity">
            <h4 className='label'>Dein Tipp für die Community</h4>
             
            <input className="tippComm" value={this.state.communityTipp} onChange={this.handleCommunityTippChange} maxLength="90" />
            
            </section>
          </div>
         
    );
  }
}
export default CommunityTippBlock;


// WEBPACK FOOTER //
// ./src/CommunityTippBlock.js